import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { map } from 'rxjs/operators';

export interface MailingList {
  listId: string;
  name: string;
  favourite: boolean;
}

@Injectable({
  providedIn: 'root'
})
export class ConstantContactService {
  private apiUrl: string = environment.apiUrl + '/NewsLetter/';

  constructor(private http: HttpClient) { }

  getMailingList(): Observable<Array<MailingList>> {
    return this.http.get<any>(this.apiUrl + 'GetOptionsList').pipe(map(it => it.data))
  }

  subscribeToListing(email: String, listingIds: string[]): Observable<boolean> {
    return this.http.post<any>(this.apiUrl + 'Subscribe', {
      email: email,
      memberShipIds: listingIds //list_id this could be the name of listing array
    }).pipe(map(it => it.data))
  }
}
